import { endpoints } from "./endpoints";

export const environment = {
	name:'MakeMark',
	firebaseConfig: {
		apiKey: "AIzaSyA_Q3lZzvOSvQb6Vus1VnEGWVnC5CoIDj0",
		authDomain: "makemark-1e712.firebaseapp.com",
		projectId: "makemark-1e712",
		storageBucket: "makemark-1e712.firebasestorage.app",
		messagingSenderId: "1042826119420",
		appId: "1:1042826119420:web:e5d585e4fff736d9e1ef79",
		vapidKey: 'BKHXM1bHUuzMfj9oBh9pTmX63-bGVrdRPAcIrxiMwudx4JLV2ujkbEY-IWC4IqvXZpSWuG0vvR7YascCXuAXz4Y'
	},
	production: true,

	api: {
		files: "https://makemark.nytelweb.com/public/",
		host: "https://makemark.nytelweb.com/",
		url: "https://makemark.nytelweb.com/api/api/auth/",
		// url: "http://192.168.20.129/MakeMarkApi/api/auth/",
		...endpoints.api,
	},
	countries: endpoints.countries,
};
